/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  CreateVelocityModel,
  DomainConvertInfo,
  ElementsConvertInfo,
  PointProjection,
} from './data-contracts'
import { ContentType, HttpClient, RequestParams } from './http-client'

export class VelocityModelingClient<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags VelocityModeling
   * @summary Создать задачу на пересчет оъектов в заданный домен с заданной ГСМ
   * @request POST:/geology/velocity-modeling/project/{projectId}/to-domain
   * @secure
   */
  velocityModelingAssociateToDomain = (
    projectId: string,
    data: DomainConvertInfo,
    params: RequestParams = {},
  ) =>
    this.http.request<ElementsConvertInfo, any>({
      path: `/geology/velocity-modeling/project/${projectId}/to-domain`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags VelocityModeling
   * @summary Тестовая ручка генерации точек для сервиса корреляции. Не для использования
   * @request POST:/geology/velocity-modeling/project/{projectId}/points
   * @deprecated
   * @secure
   */
  velocityModelingGetProjections = (
    projectId: string,
    data: CreateVelocityModel,
    params: RequestParams = {},
  ) =>
    this.http.request<PointProjection[][], any>({
      path: `/geology/velocity-modeling/project/${projectId}/points`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })
}
